export default [
  {
    id: "showIdentifier",
    label: "Item Identifier",
    onChangeFunctionName: "changeShowIdentifier"
  },
  { id: "showDates", label: "Date", onChangeFunctionName: "changeShowDates" },
  {
    id: "showDuration",
    label: "Duration",
    onChangeFunctionName: "changeShowDuration"
  },
  {
    id: "showNarrative",
    label: "Narrative Position",
    onChangeFunctionName: "changeShowNarrative"
  },
  {
    id: "showSummary",
    label: "Summary",
    onChangeFunctionName: "changeShowSummary"
  },
  {
    id: "showBlockedBy",
    label: "Blocked by",
    onChangeFunctionName: "changeShowBlockedBy"
  },
  {
    id: "showBlocks",
    label: "Blocks",
    onChangeFunctionName: "changeShowBlocks"
  },
  { id: "showImage", label: "Image", onChangeFunctionName: "changeShowImage" }
];
